import { render, staticRenderFns } from "./LBGebouwLayer.vue?vue&type=template&id=47e0e748"
import script from "./LBGebouwLayer.vue?vue&type=script&lang=js"
export * from "./LBGebouwLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports